// extracted by mini-css-extract-plugin
export default {"canvasBlock":"breathBlock_canvasBlock__ZORI2","canvas":"breathBlock_canvas__st+ZS","btnBlock":"breathBlock_btnBlock__qxdPK","btn":"breathBlock_btn__G7Vy8"};